import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const CardSegment = ({ segment }) => {
  if (segment.url) {
    return (
      <Link to={segment.url} className="segment segment-card">
        <div className="background" style={{ backgroundImage: `url('${segment.image}')` }} />
        {segment.title ? <h4>{segment.title}</h4> : null}
        {segment.text ? <p>{segment.text}</p> : null}
      </Link>
    );
  }

  return (
    <div className="segment segment-card">
      <div className="background" style={{ backgroundImage: `url('${segment.image}')` }} />
      {segment.title ? <h4>{segment.title}</h4> : null}
      {segment.text ? <p>{segment.text}</p> : null}
    </div>
  );
};

CardSegment.propTypes = {
  segment: PropTypes.object.isRequired,
};

export default CardSegment;



// WEBPACK FOOTER //
// ./src/components/blocks/double/segment/card.js